const SCHEME = 'terros://'

export type WithOptionalScheme = {
  includeScheme?: boolean
}

export const withScheme = (url: string, includeScheme = false): string => {
  if (!includeScheme) return `/${url}`
  return `${SCHEME}${url}`
}
